import { Channel } from './channel';

export class ChannelsData {
  channels: Channel[] = [];

  pageNumber = 0;

  numberOfItems = 20;

  // this will be false when there is no more channels on backend
  getNextPage = true;

  get totalNumberOfUnreadMessaages() {
    const temp = this.channels.reduce((prev, next) => prev + (next.numberOfUnread || 0), 0);
    return temp < 0 ? 0 : temp;
  }
}
